import LTR from "@brand-icons/ploom/store-default/store-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const StoreDefaultIcon = iconFactory("StoreDefaultIcon", LTR);
